import { GameStatus } from "../../models/GameStatus";
import store from "../../store/store";
import Card from "../Card/Card";
import { gameActions } from "../Game/gameSlice";
import "./Hand.scss";

export default function HandMatch() {

  const gameState = store.getState().game;
  const userState = store.getState().user;
  const player = gameState.player;

  const isMatchCard =
    gameState.status === GameStatus.MATCH &&
    !player?.data.isStoryteller &&
    !player?.data.hasMatched;

  function select(cardId: string) {
    if (player && isMatchCard) {
      store.dispatch(gameActions.selectMatchCard({
        gameId: gameState.gameId,
        playerId: player.data.playerId,
        matchCardId: cardId}
      ));
    }
  }

  const isMatching = gameState.status === GameStatus.MATCH;

  function confirm(cardId: string) {
    if (player) {

      if (isMatching) {
        store.dispatch(gameActions.submitMatch({
          gameId: gameState.gameId,
          playerId: player.data.playerId,
          matchCardId: player.matchCardId
        }));
      }
    }
  }

  const isSelectable =
    (!!player?.matchCardId && !player?.data.hasMatched) || !player?.matchCardId;

  return (
    <>
      <div className="table-hand table-hand_match">
        {player?.hand.map((it) => {
          const isConfirm = (it.cardId === gameState.player?.matchCardId);
          return (
            <Card
              card={it}
              cards={player?.hand}
              key={it.cardId}
              isSelected={player.matchCardId === it.cardId}
              isSelectable={isSelectable}
              onSelect={() => select(it.cardId)}
              onConfirm={() => confirm(it.cardId)}
              isConfirm={isConfirm || undefined}
              confirmPrompt={userState.user.confirmActionEnabled ? `Are you sure you want to select this card?` : null}
            />
          )}
        )}
      </div>
    </>
  )
}